import Cookies from 'js-cookie'

/**
 * Cookies
 * @param {*} name 名称
 * @param {*} value 值
 * @param {*} ext 配置
 */

export function setCookie(name, value, ext = {}) {
  Cookies.set(name, value, ext)
}

export function getCookie(name, ext = {}) {
  return Cookies.get(name, ext)
}

export function removeCookie(name, ext = {}) {
  Cookies.remove(name, ext)
}

/**
 * Storage
 * @param {*} name 名称
 * @param {*} value 值
 */

export function setStorage(name, value) {
  return localStorage.setItem(name, value)
}

export function getStorage(name) {
  return localStorage.getItem(name)
}

export function setStorageJSON(name, value = {}) {
  return localStorage.setItem(name, JSON.stringify(value))
}

export function getStorageJSON(name, defultData = '{}') {
  return JSON.parse(localStorage.getItem(name) || defultData)
}

export function removeStorage(name) {
  return localStorage.removeItem(name)
}

export function clearStorage() {
  return localStorage.clear()
}

/**
 * Session
 * @param {*} name 名称
 * @param {*} value 值
 */

export function setSession(name, value) {
  return sessionStorage.setItem(name, value)
}

export function getSession(name) {
  return sessionStorage.getItem(name)
}
export function setLocal(name, value) {
  return localStorage.setItem(name, value)
}

export function getLocal(name) {
  return localStorage.getItem(name)
}
export function removeLocal(name) {
  return localStorage.removeItem(name)
}

export function setSessionJSON(name, value = {}) {
  return sessionStorage.setItem(name, JSON.stringify(value))
}

export function getSessionJSON(name, defultData = '{}') {
  return JSON.parse(sessionStorage.getItem(name) || defultData)
}

export function removeSession(name) {
  return sessionStorage.removeItem(name)
}

export function clearSession() {
  return sessionStorage.clear()
}